import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { ErrorMessage } from '@hookform/error-message';
import { Input } from 'reactstrap';

const InputField = (props) => {
  const {
    control,
    formState: { errors },
    clearErrors,
  } = useFormContext();

  const {
    children,
    hideFormError,
    name: propsName,
    clearError,
    shouldUnregister,
    type,
    customHandleChange,
    ...inputProps
  } = props;

  return (
    <>
      <Controller
        name={propsName}
        control={control}
        shouldUnregister={shouldUnregister}
        render={({ field: { onChange, onBlur, value } }) => (
          <Input
            type={type}
            onBlur={onBlur}
            {...inputProps}
            value={value}
            onChange={(event) => {
              if (type === 'file') {
                onChange(event?.target?.files);
              } else {
                onChange(event);
              }
              if (clearError) {
                clearErrors();
              }
              if (customHandleChange) {
                customHandleChange(event);
              }
            }}
          />
        )}
      />
      {!hideFormError ? (
        <ErrorMessage
          errors={errors}
          name={propsName}
          render={({ message }) => (
            <small className="text-danger">{message}</small>
          )}
        />
      ) : (
        ''
      )}
    </>
  );
};

export default InputField;
